// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3xMxp","right":"styles_right__1m1r5"};